import React from 'react'

import PropTypes from 'prop-types'

import { iconNames } from './iconNames'

import css from './Icon.module.css'

const ICON_CLASSES = {
  calendar: css.calendar,
  leaf: css.leaf,
  frequency: css.frequency,
  home: css.home,
  mealPerBox: css.mealPerBox,
  profile: css.profile,
  portions: css.portions,
}

const Icon = ({ name, testingSelector }) =>
  iconNames.includes(name) ? (
    <span className={ICON_CLASSES[name]} data-testing={testingSelector} />
  ) : null

Icon.propTypes = {
  name: PropTypes.oneOf(iconNames).isRequired,
  testingSelector: PropTypes.string,
}

Icon.defaultProps = {
  testingSelector: null,
}

export { Icon }
